import React from 'react'
import './styles.scss'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import CandidatesRows from 'components/candidatesRows'

export class CandidatesList extends React.Component {
  constructor(props) {
    super(props)
    this.intervalId = setInterval(() => {
      this.refresh()
    }, 60000)
    this.state = {
      round: 1,
      showAllCandidates: false,
      data: null
    }
  }

  componentDidMount() {
    this.refresh()
  }

  componentDidUpdate(oldProps) {
    console.log('UPDATE')

    if (
      oldProps.match.params.electionId !== this.props.match.params.electionId
    ) {
      this.refresh()
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  refresh() {
    window
      .fetch(
        'https://interactif.tdg.ch/municipalities-elections/' +
          this.props.match.params.electionId +
          '.json?' +
          Math.random()
      )
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState({
          data: data,
          round:
            data[0].candidates.reduce(
              (a, b) => a + (+b['votes round 2'] || 0),
              0
            ) > 0
              ? 2
              : 1
        })
        console.log(data)
        console.log(data[0].related_stories)
      })
  }

  getAgreement(candidatesList) {
    let agreement = ''

    const genders = candidatesList.reduce((a, b) => [...a, b.sex], [])

    if (genders.length === 1 && genders[0] === 'f') {
      agreement = 'e'
    }

    if (candidatesList.length > 1) {
      agreement += 's'
    }

    return agreement
  }


  render() {
    const limit =
      new URLSearchParams(this.props.location.search).get('limit') || 3
    const DATA = this.state.data ? this.state.data[0] : null
    let electionStateMsg = <div>Chargement</div>
    let electionState = 0
    let hasTwoRounds = false
    const rounds = {
      1: {
        electedCandidates: [],
        nonElectedCandidates: []
      },
      2: {
        electedCandidates: [],
        nonElectedCandidates: []
      }
    }
    let agreement = {
      elected: '',
      nonElected: ''
    }

    if (DATA) {
      DATA.candidates.sort(function(a, b) {
        return b['votes round 1'] - a['votes round 1']
      })

      hasTwoRounds =
        DATA.candidates.reduce((a, b) => a + (+b['votes round 2'] || 0), 0) > 0
      rounds[1].electedCandidates = DATA.candidates.filter(
        candidate => candidate.elected
      )
      rounds[1].nonElectedCandidates = DATA.candidates.filter(
        candidate => !candidate.elected && candidate['attends round 1']
      )

      rounds[2].electedCandidates = DATA.candidates.filter(
        candidate => candidate.elected
      )
      rounds[2].nonElectedCandidates = DATA.candidates.filter(
        candidate => !candidate.elected && candidate['attends round 2']
      )

      if (
        DATA.candidates.reduce(
          (a, b) => a + (+b['votes round ' + this.state.round] || 0),
          0
        ) > 0 &&
        DATA.done === false
      ) {
        electionState = 1
        electionStateMsg = (
          <>
            Dépouillement en cours, dernière mise à jour à {DATA.last_updated}
          </>
        )
      } else if (DATA.done === true) {
        electionState = 2
        electionStateMsg = (
          <>
            Résultat final{' '}
            <img
              width='14px'
              height='auto'
              src={require('../../images/checked.svg')}
            />
          </>
        )
      } else {
        electionState = 0
        electionStateMsg = <>Retrouvez bientôt les résultats en direct.</>
      }

      agreement = {
        elected: this.getAgreement(rounds[this.state.round].electedCandidates),
        nonElected: this.getAgreement(
          rounds[this.state.round].nonElectedCandidates
        )
      }
    }

    return (
      <div className='ui text container'>
        {!DATA ? (
          <div className='loading-container'>
            <div className='ui active dimmer'>
              <div className='ui loader' />
            </div>
          </div>
        ) : (
          <div>
            {(DATA.title || DATA.subtitle) && (
              <h4 className='ui header'>
                <div className='content'>
                  {!this.props.hideTitle && DATA.title}
                  <div className='sub header'>{DATA.subtitle}</div>
                </div>
              </h4>
            )}

            <div className='round'>
              <div
                className={this.state.round === 1 ? 'active' : ''}
                onClick={() => {
                  this.setState({ round: 1 })
                }}
              >
                Premier tour
              </div>
              {hasTwoRounds && (
                <div
                  className={this.state.round === 2 ? 'active' : ''}
                  onClick={() => {
                    this.setState({ round: 2 })
                  }}
                >
                  Deuxième tour
                </div>
              )}
            </div>

            <div className='election-state'>{electionStateMsg}</div>

            <div className='candidates-wrapper'>
              {rounds[this.state.round].electedCandidates.length > 0 && (
                <div className='elected candidates-bloc'>
                  <div className='list-label-top'>
                    <small>Élu{agreement.elected}</small>
                    <small>Voix</small>
                  </div>
                  <CandidatesRows
                    absMajority={+DATA.clear_majority}
                    validVotes={+DATA[this.state.round + 'st round votes']}
                    round={this.state.round}
                    candidates={rounds[this.state.round].electedCandidates}
                  />
                </div>
              )}
              <div className='non-elected candidates-bloc'>
                {electionState !== 0 && (
                  <div className='list-label-top'>
                    <small>Non élu{agreement.nonElected}</small>
                    <small>Voix</small>
                  </div>
                )}
                <CandidatesRows
                  absMajority={+DATA.clear_majority}
                  validVotes={+DATA[this.state.round + 'st round votes']}
                  round={this.state.round}
                  candidates={rounds[this.state.round].nonElectedCandidates}
                  limit={
                    this.state.showAllCandidates
                      ? false
                      : limit -
                        rounds[this.state.round].electedCandidates.length
                  }
                />
              </div>
            </div>
            {rounds[this.state.round].nonElectedCandidates.length +
              rounds[this.state.round].electedCandidates.length >
              limit && (
              <div
                className='more-candidates-trigger'
                onClick={() => {
                  this.setState(state => ({
                    showAllCandidates: !state.showAllCandidates
                  }))
                }}
              >
                {this.state.showAllCandidates ? (
                  <div>
                    <i className='ui icon chevron up' /> Montrer moins de
                    candidats
                  </div>
                ) : (
                  <div>
                    <i className='ui icon chevron down' /> Tous les candidats
                  </div>
                )}
              </div>
            )}

            {this.state.data[0].related_stories.length > 0 && (
              <div className='related-stories'>
                <div>
                  <b>Articles en relation</b>
                </div>
                <ArticleTeasers
                  sorting='reverse chronologically by creation date'
                  numberOfCards='three'
                  articleIds={this.state.data[0].related_stories}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default CandidatesList
